import { render, staticRenderFns } from "./management.vue?vue&type=template&id=1fe8359a&scoped=true"
import script from "./management.vue?vue&type=script&lang=js"
export * from "./management.vue?vue&type=script&lang=js"
import style0 from "./management.vue?vue&type=style&index=0&id=1fe8359a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe8359a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fe8359a')) {
      api.createRecord('1fe8359a', component.options)
    } else {
      api.reload('1fe8359a', component.options)
    }
    module.hot.accept("./management.vue?vue&type=template&id=1fe8359a&scoped=true", function () {
      api.rerender('1fe8359a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/setup/dictionary/management.vue"
export default component.exports